import React, { useRef } from 'react';
import Select from 'react-select';
import useSetState from '../../../../hooks/useSetState';
import ShowForPermission from '../../../../components/ShowForPermission';
import DatePicker from '../../../../components/FormElements/DatePicker/DatePicker';
import ENUMS from '../../../../enums';

const PackagesReportTabFilters = ({
  data,
  pageNumber,
  pageSize,
  applyFilters,
  getRseePackagesSalesReport,
  resetForm,
}) => {
  let formRefrence = useRef();

  const [controls, setControls] = useSetState({
    name: '',
    fromDate: '',
    toDate: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const rseePackageList = data => {
    const listItems = data.map(item => ({
      label: item.name,
      value: item.name,
    }));
    return listItems;
  };

  const onSubmit = event => {
    event.preventDefault();
    applyFilters(event, controls.name, controls.fromDate, controls.toDate);
  };

  const onReset = () => {
    onChangeValue('name', '');
    onChangeValue('fromDate', ' ');
    onChangeValue('toDate', ' ');
    resetForm();
    getRseePackagesSalesReport(pageNumber, pageSize);
  };

  return (
    <section className='bg-white my-2'>
      <form
        ref={formRefrence}
        onSubmit={event => onSubmit(event)}
        id='filterForm'
        className='card card my-4'
      >
        <header className='text-center card-header'>
          <h5 className='font-italic text-muted'>{locales('titles.filter')}</h5>
        </header>
        <main className='card-body'>
          <div className='d-flex row flex-lg-row flex-sm-column col-12 flex-md-row justify-content-between px-1 mx-1'>
            <div className='d-flex col-lg-3 col-md-12 col-sm-12 mx-1'>
              <label className='rsee-form-label col-lg-5'>
                {locales('fields.startDate')}
              </label>
              <div className='full-width'>
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.startDate')}
                  name='fromDate'
                  onChange={val => onChangeValue('fromDate', val)}
                  value={controls.fromDate}
                  className='date-picker-input'
                />
              </div>
            </div>
            <div className='d-flex col-lg-3 col-md-12 col-sm-12 mx-1'>
              <label className='rsee-form-label col-lg-4'>
                {locales('fields.endDate')}
              </label>
              <div className='full-width'>
                <DatePicker
                  marge={true}
                  placeholder={locales('fields.endDate')}
                  name='toDate'
                  onChange={val => onChangeValue('toDate', val)}
                  value={controls.toDate}
                  className='date-picker-input'
                />
              </div>
            </div>
            <div className='d-flex col-lg-5 col-md-12 col-sm-12 mx-1'>
              <ShowForPermission
                permission={ENUMS.PERMISSIONS.values.VIEW_RSEE_PACKAGES_LIST}
              >
                <label className='rsee-form-label'>
                  {locales('package.name')}
                </label>
                <div className='full-width'>
                  <Select
                    id='type'
                    name='type'
                    placeholder={locales('package.name')}
                    isMulti={false}
                    options={rseePackageList(data)}
                    onChange={e => onChangeValue('name', e)}
                    value={controls.name}
                  />
                </div>
              </ShowForPermission>
            </div>
          </div>

          <div className='col-12 d-flex justify-content-end p-0 my-3'>
            <button
              type='button'
              onClick={onReset}
              className='btn btn-danger w-5 mx-2'
            >
              {locales('fields.reset')}
            </button>
            <button type='submit' className='btn btn-success w-5 mx-2'>
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </section>
  );
};

export default PackagesReportTabFilters;
